import { useTranslation } from 'react-i18next'

import { InputWithLabel, ScrollableTabs, Switch, Text } from '@reveni-io/reveni-ui'

import useBlockSettingTranslatedText from './hooks/useBlockSettingTranslatedText/useBlockSettingTranslatedText'
import * as Styles from './styles'

const BlockSettingTranslatedTextField = ({ field, value, onChange }) => {
  const { t } = useTranslation()
  const {
    languageTabs,
    selectedLanguage,
    selectLanguage,
    customTextEnabled,
    showTextInput,
    hasSelectedLanguageError,
    handleChangeText,
    handleToggleCustomText,
  } = useBlockSettingTranslatedText({ field, value, onChange })

  const label = t(field.label)

  return (
    <Styles.Container>
      {label && <Text type="bodyMRegular">{label}</Text>}
      {field.showToggle && (
        <Switch checked={customTextEnabled} onChange={handleToggleCustomText} label={t(field.toggleLabel)} />
      )}
      {showTextInput && (
        <>
          <ScrollableTabs tabs={languageTabs} value={selectedLanguage} onChange={selectLanguage} />
          <InputWithLabel
            label={label}
            placeholder={t(field.placeholder)}
            value={value?.[selectedLanguage] || ''}
            onChange={handleChangeText}
            error={hasSelectedLanguageError}
            helperText={hasSelectedLanguageError ? t('Este campo es obligatorio') : ''}
            fullWidth
          />
        </>
      )}
    </Styles.Container>
  )
}

export default BlockSettingTranslatedTextField
